import type {ViewableFile} from 'src/typings';
import type {FileViewForm} from 'shared/constants';
import type {FileDataService} from '../../features/file/file.data-service';

export class FilesSelectionModalService {
    public static serviceName = 'filesSelectionModalService'

    /*@ngInject*/
    constructor(private fileDataService: FileDataService) {
    }

    public async getAllFiles(parentDirectoryIds: number[], fileViewForms?: FileViewForm[]): Promise<ViewableFile[]> {
        return this.fileDataService.queryFiles({
            rootDirectory: parentDirectoryIds,
            fileViewForm: fileViewForms
        });
    }
}